import type { ReactNode } from 'react'

type Variant = 'info' | 'warning' | 'tip'

interface Props {
  type?: Variant
  title?: string
  children: ReactNode
}

export default function Callout({ type = 'info', title, children }: Props) {
  return (
    <aside className={`callout callout-${type}`} role="note">
      {title && <p className="callout-title">{title}</p>}
      {children}
    </aside>
  )
}
